import { render } from "./DeletePhotoUserModal.vue?vue&type=template&id=84edc48e&scoped=true"
import script from "./DeletePhotoUserModal.vue?vue&type=script&lang=js"
export * from "./DeletePhotoUserModal.vue?vue&type=script&lang=js"

import "./DeletePhotoUserModal.vue?vue&type=style&index=0&id=84edc48e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84edc48e"]])

export default __exports__